import React from "react";
import "./Spinner.css";
function Loader() {
  return (
    <div className="loaderParent">
      <div className="loader">
        <div className="face">
          <div className="circle"></div>
        </div>
        <div className="face">
          <div className="circle"></div>
        </div>
        <div className="face">
          <div className="circle"></div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
